import { useRecoilValue, useSetRecoilState } from "recoil";
import WxContentsDispatcher from "./WxContentsDispatcher";
import { potekaElementState } from "../../../store/PotekaElementState";
import { contractConfigState } from "../../../store/ContractConfigState";
import { useEffect } from "react";

const PotekaDispatcher = (props) => {
  const setPotekaElementInfo = useSetRecoilState(potekaElementState);
  const {specificPotekaIds} = useRecoilValue(contractConfigState);

  props.contents.setPotekaElementInfoDispatcher((typeInfo) => {
    setPotekaElementInfo(typeInfo);
  });

  useEffect(() => {
    props.contents.setSpecificPotekaIds(specificPotekaIds);
  }, [props.contents, specificPotekaIds]);

  return <WxContentsDispatcher {...props}/>
};

export default PotekaDispatcher;
